import { Loading, ModalSmall } from '@schooly/style';
import { FC, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useEvent } from '../../../context/events/WithEvent';
import { useRouter } from '../../../context/router/useRouter';
import { defaultValues, EventCreateContent, EventCreateContentProps } from './EventCreateContent';

export interface EventCreateModalProps extends EventCreateContentProps {
  fetching?: boolean;
}

export const EVENT_CREATE_GROUP_ID_SEARCH_PARAM = 'group_id';

export const EventCreateModal: FC<EventCreateModalProps> = ({
  defaultValues: propsDefaultValues,
  onClose: propsOnClose,
  fetching: propsFetching,
  ...rest
}) => {
  const { fetching } = useEvent();
  const [searchParams] = useSearchParams();
  const { goBack } = useRouter();

  const groupId = searchParams.get(EVENT_CREATE_GROUP_ID_SEARCH_PARAM);
  const onClose = groupId ? goBack : propsOnClose;

  const showLoader = fetching || propsFetching;

  const eventCreateDefaultValues = useMemo(() => {
    if (!groupId) return propsDefaultValues;

    return {
      ...defaultValues,
      ...propsDefaultValues,
      criteria: {
        ...defaultValues.criteria,
        ...propsDefaultValues?.criteria,
        group_ids: [groupId],
      },
    };
  }, [groupId, propsDefaultValues]);

  return (
    <ModalSmall open>
      {showLoader ? (
        <Loading />
      ) : (
        <EventCreateContent defaultValues={eventCreateDefaultValues} onClose={onClose} {...rest} />
      )}
    </ModalSmall>
  );
};
